import {builderComponents} from './builderComponents'

/**
 * An array of Mantine component metadata for use in FormViewer.
 */
export const models = builderComponents.map(({model}) => model)
